import React, { useEffect, useState } from "react";
import { api } from "../api.js";

/** The splash: the hoopoe, the name, one password field. Nothing else until it opens. */
const Splash: React.FC<{ checking: boolean; onOpen: () => void }> = ({ checking, onOpen }) => {
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [shake, setShake] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!pw || busy) return;
    setBusy(true);
    try { await api.login(pw); onOpen(); } catch (e: any) { setMsg(e.message === "that is not it" ? "That's not it." : e.message); setShake(true); setTimeout(() => setShake(false), 500); setPw(""); } finally { setBusy(false); }
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "radial-gradient(ellipse at 50% 30%, #23603a 0%, #1B4D2E 45%, #0B0F0D 100%)", display: "flex", alignItems: "center", justifyContent: "center", color: "#F7F5EF", fontFamily: "'Inter Tight', system-ui, sans-serif", zIndex: 1000 }}>
      <style>{`@keyframes hudhud-float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-8px) } } @keyframes hudhud-shake { 0%,100% { transform: translateX(0) } 20%,60% { transform: translateX(-8px) } 40%,80% { transform: translateX(8px) } }`}</style>
      <div className="col" style={{ alignItems: "center", gap: 18, width: 340, padding: 24 }}>
        <img src="/assets/brand/hudhud.png" alt="" style={{ width: 168, height: 168, borderRadius: "50%", boxShadow: "0 30px 80px rgba(0,0,0,0.5)", animation: "hudhud-float 5s ease-in-out infinite" }} />
        <div className="col" style={{ alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 34, fontWeight: 900, letterSpacing: -1 }}>Al-Hudhud</span>
          <span style={{ fontSize: 13, opacity: 0.7, letterSpacing: 2, textTransform: "uppercase" }}>Reel Studio</span>
        </div>
        {checking ? <span style={{ opacity: 0.6, fontSize: 13 }}>One moment…</span> : (
          <form onSubmit={(e) => { e.preventDefault(); submit(); }} className="col" style={{ gap: 10, width: "100%", animation: shake ? "hudhud-shake 0.5s" : undefined }}>
            <input type="password" autoFocus autoComplete="current-password" placeholder="Password" aria-label="Password" value={pw} onChange={(e) => setPw(e.target.value)} style={{ width: "100%", padding: "14px 16px", fontSize: 16, borderRadius: 12, border: "1px solid rgba(245,197,66,0.5)", background: "rgba(11,15,13,0.55)", color: "#F7F5EF", textAlign: "center", letterSpacing: 4, boxSizing: "border-box" }} />
            <button type="submit" className="btn gold" disabled={!pw || busy} style={{ width: "100%", justifyContent: "center", padding: 12, fontSize: 15 }}>{busy ? "…" : "Enter"}</button>
            <span style={{ minHeight: 18, fontSize: 13, textAlign: "center", color: "#F5C542" }}>{msg ?? ""}</span>
          </form>
        )}
      </div>
    </div>
  );
};

/** Nothing renders until the studio's door is open; a 401 from any call closes it again. */
export const Gate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<"checking" | "locked" | "open">("checking");
  useEffect(() => {
    api.session().then((s) => setState(s.authed ? "open" : "locked")).catch(() => setState("locked"));
    const lock = () => setState("locked");
    window.addEventListener("hudhud:locked", lock);
    return () => window.removeEventListener("hudhud:locked", lock);
  }, []);
  if (state === "open") return <>{children}</>;
  return <Splash checking={state === "checking"} onOpen={() => setState("open")} />;
};
